import { useState, useEffect } from 'react';

const BREAKPOINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};

const useViewportSize = () => {
  const getBreakpointData = width => {
    let breakpoint = 'xs';

    if (width >= BREAKPOINTS.xxl) {
      breakpoint = 'xxl';
    } else if (width >= BREAKPOINTS.xl) {
      breakpoint = 'xl';
    } else if (width >= BREAKPOINTS.lg) {
      breakpoint = 'lg';
    } else if (width >= BREAKPOINTS.md) {
      breakpoint = 'md';
    } else if (width >= BREAKPOINTS.sm) {
      breakpoint = 'sm';
    }

    return {
      breakpoint,
      isXs: breakpoint === 'xs',
      isSm: breakpoint === 'sm',
      isMd: breakpoint === 'md',
      isLg: breakpoint === 'lg',
      isXl: breakpoint === 'xl',
      isXxl: breakpoint === 'xxl',

      isSmUp: width >= BREAKPOINTS.sm,
      isMdUp: width >= BREAKPOINTS.md,
      isLgUp: width >= BREAKPOINTS.lg,
      isXlUp: width >= BREAKPOINTS.xl,
      isXxlUp: width >= BREAKPOINTS.xxl,

      isSmDown: width < BREAKPOINTS.md,
      isMdDown: width < BREAKPOINTS.lg,
      isLgDown: width < BREAKPOINTS.xl,
      isXlDown: width < BREAKPOINTS.xxl,
      isXxlDown: true
    };
  };

  const [viewport, setViewport] = useState(() => {
    if (typeof window === 'undefined') {
      return {
        width: 0,
        height: 0,
        breakpoint: 'xs',
        isXs: true,
        isSm: false,
        isMd: false,
        isLg: false,
        isXl: false,
        isXxl: false,
        isSmUp: false,
        isMdUp: false,
        isLgUp: false,
        isXlUp: false,
        isXxlUp: false,
        isSmDown: true,
        isMdDown: true,
        isLgDown: true,
        isXlDown: true,
        isXxlDown: true
      };
    }

    const width = window.innerWidth;
    const height = window.innerHeight;

    return {
      width,
      height,
      ...getBreakpointData(width)
    };
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setViewport({
        width,
        height,
        ...getBreakpointData(width)
      });
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return viewport;
};

export default useViewportSize;
